import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild } from '@angular/router';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { RedirectService } from './shared/services/redirect.service';
import { ENV } from './environment';
import { UserService } from '@yotpo-ui/platform-core';

@Injectable()
export class RoleGuard implements CanActivate, CanActivateChild {
  constructor(private userService: UserService,
    private redirectService: RedirectService
  ) { }
  canActivateChild(): Observable<boolean> {
    return this.canActivate();
  }

  canActivate(): Observable<boolean> {
    return this.userService.getUserData().pipe(
      map((userData: any) => {
        if (!userData.moderatorRole || userData.moderatorRole.toLowerCase() === 'reviews moderator') {
          this.redirectService.redirectTo(ENV.YotpoNewB2bEndpoint);
          return false;
        }
        return true;
      }),
      catchError(() => {
        return of(false);
      }));
  }
}
